import { NgModule } from '@angular/core';
import { DemoHomeComponent } from './demo-home.component';

@NgModule({
  declarations: [
    DemoHomeComponent,
  ],
  imports: [
  ],
})
export class DemoHomeModule { }
